import PropTypes from 'prop-types';
import React from 'react';
import ConvertedUnits from 'src/components/ConvertedUnits';
import Input from 'src/components/CustomInput';
import useConvertedInputHandler from 'src/hooks/useConvertedInputHandler';
import useActionPanelStore from 'src/stores/useActionPanelStore';
import { MATERIAL_UNITS, MEASUREMENT_SYSTEM } from 'src/utils/constants';
import { getUnitsSettings } from 'src/utils/conversions';

const EditTareWeightPanel = ({ additionalText, label, currentTareWeight, updateTareWeight }) => {
  const {
    baseValue,
    convertedValue,
    convertedUnits,
    handleInputChange,
  } = useConvertedInputHandler(currentTareWeight, MATERIAL_UNITS.GRAM, true);

  const { closeActionPanel } = useActionPanelStore();

  // Get the user's measurement system to determine if we should show the tooltip
  const { measurementSystem } = getUnitsSettings();
  // Skip tooltip if we're using the metric system (only show tooltip for imperial)
  const shouldSkipTooltip = measurementSystem === MEASUREMENT_SYSTEM.METRIC;

  const handleUpdateTareWeight = async () =>
    await updateTareWeight(baseValue); // Send base value (grams) to backend

  return (
    <div>
      <div className="mb10">
        <strong>Current Weight:</strong>&nbsp;
        <ConvertedUnits
          useUserSystemUnit
          quantity={currentTareWeight}
          units={MATERIAL_UNITS.GRAM}
          skipTooltip={shouldSkipTooltip}
        />
      </div>
      {additionalText && (
        <div className="mb10">
          {additionalText}
        </div>
      )}
      <Input
        label={label}
        type="number"
        name="NewTareWeight"
        value={convertedValue}
        suffix={convertedUnits}
        step="0.001"
        min="0"
        onChange={handleInputChange}
      />
      <button
        type='button'
        className='btn btn-lg btn-primary action-btn btn-block mt60'
        onClick={handleUpdateTareWeight}
      >
        Save
      </button>
      <button type='button' className='btn btn-lg btn-block' onClick={closeActionPanel}>
        Cancel
      </button>
    </div>
  );
};

EditTareWeightPanel.defaultProps = {
  label: 'New Weight:',
  additionalText: '',
}

EditTareWeightPanel.propTypes = {
  label: PropTypes.string,
  additionalText: PropTypes.string,
  currentTareWeight: PropTypes.number,
  updateTareWeight: PropTypes.func.isRequired,
}

export default EditTareWeightPanel;
